import { Country } from '@/constructs/Country';
import { NotImplementedError } from '@/utils/errors';
import { isNullish } from '@/utils/null-utils';
import { IconTypes } from './IconTypes';

/**
 * Map for linking a country with an `IconType`.
 */
export const COUNTRY_TO_FLAG_MAP = new Map<Country, IconTypes>([
  [Country.AD, IconTypes.ADFlag],
  [Country.AE, IconTypes.AEFlag],
  [Country.AL, IconTypes.ALFlag],
  [Country.AT, IconTypes.ATFlag],
  [Country.AU, IconTypes.AUFlag],
  [Country.BA, IconTypes.BAFlag],
  [Country.BE, IconTypes.BEFlag],
  [Country.BG, IconTypes.BGFlag],
  [Country.BR, IconTypes.BRFlag],
  [Country.CA, IconTypes.CAFlag],
  [Country.CH, IconTypes.CHFlag],
  [Country.CL, IconTypes.CLFlag],
  [Country.CN, IconTypes.CNFlag],
  [Country.CO, IconTypes.COFlag],
  [Country.CY, IconTypes.CYFlag],
  [Country.CZ, IconTypes.CZFlag],
  [Country.DE, IconTypes.DEFlag],
  [Country.DK, IconTypes.DKFlag],
  [Country.DZ, IconTypes.DZFlag],
  [Country.EE, IconTypes.EEFlag],
  [Country.ES, IconTypes.ESFlag],
  [Country.FI, IconTypes.FIFlag],
  [Country.FR, IconTypes.FRFlag],
  [Country.GB, IconTypes.GBFlag],
  [Country.GR, IconTypes.GRFlag],
  [Country.HK, IconTypes.HKFlag],
  [Country.HR, IconTypes.HRFlag],
  [Country.HU, IconTypes.HUFlag],
  [Country.ID, IconTypes.IDFlag],
  [Country.IE, IconTypes.IEFlag],
  [Country.IL, IconTypes.ILFlag],
  [Country.IS, IconTypes.ISFlag],
  [Country.IT, IconTypes.ITFlag],
  [Country.JE, IconTypes.JEFlag],
  [Country.JP, IconTypes.JPFlag],
  [Country.KR, IconTypes.KRFlag],
  [Country.KZ, IconTypes.KZFlag],
  [Country.LT, IconTypes.LTFlag],
  [Country.LU, IconTypes.LUFlag],
  [Country.LV, IconTypes.LVFlag],
  [Country.MA, IconTypes.MAFlag],
  [Country.MC, IconTypes.MCFlag],
  [Country.MD, IconTypes.MDFlag],
  [Country.ME, IconTypes.MEFlag],
  [Country.MK, IconTypes.MKFlag],
  [Country.MT, IconTypes.MTFlag],
  [Country.NL, IconTypes.NLFlag],
  [Country.NO, IconTypes.NOFlag],
  [Country.NZ, IconTypes.NZFlag],
  [Country.PH, IconTypes.PHFlag],
  [Country.PL, IconTypes.PLFlag],
  [Country.PT, IconTypes.PTFlag],
  [Country.RE, IconTypes.REFlag],
  [Country.RO, IconTypes.ROFlag],
  [Country.RS, IconTypes.RSFlag],
  [Country.RU, IconTypes.RUFlag],
  [Country.SE, IconTypes.SEFlag],
  [Country.SG, IconTypes.SGFlag],
  [Country.SI, IconTypes.SIFlag],
  [Country.SK, IconTypes.SKFlag],
  [Country.TN, IconTypes.TNFlag],
  [Country.TR, IconTypes.TRFlag],
  [Country.TW, IconTypes.TWFlag],
  [Country.US, IconTypes.USFlag],
  [Country.ZA, IconTypes.ZAFlag]
]);

/**
 * Returns the appropriate `IconType` for the given country.
 * Falls back to a Globe icon when no flag is available.
 * @param country - The country to get its flag.
 * @returns The appropriate `IconType`.
 * @throws A {@link NotImplementedError} if the country does not have an icon assigned to it.
 */
export const getFlagByCountry = (country: Country): IconTypes => {
  const flag = COUNTRY_TO_FLAG_MAP.get(country);

  if (isNullish(flag)) {
    throw new NotImplementedError(
      `The country ${country} does not have an icon assigned to it.`
    );
  }

  return flag;
};
